import React, { forwardRef } from 'react';

export type LinkProps = React.ComponentPropsWithRef<'a'>;

const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
  return <a ref={ref} className='sku-link' {...props}>{props.children}</a>;
});

export default Link;
